import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import webhookIcon from "../../../../../assets/icons/webhook.png";
import mailIcon from "../../../../../assets/icons/mail.png";
import Close from "@material-ui/icons/Close";
import EmailTrigger from "../../EmailTrigger/EmailTrigger";
import WebHook from "../../webHook/WebHook";

const buttonStyle = {
  minWidth: 200,
  height: 40,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "0.5px solid #C8C8C8",
  borderRadius: 5,
  cursor: "pointer",
  marginBottom: 15,
};
const labelStyle = {
  color: "#6B6B6B",
  fontSize: 13,
  marginLeft: 5,
  fontWeight: 600,
};

const TriggerModal = (props) => {
  const { t } = useTranslation();
  const [openEmailTrigger, setOpenEmailTrigger] = useState(false);
  const [openWebHook, setOpenWebHook] = useState(true);
  const [tab, setTab] = useState(1);
  const [triggerType, setTriggerType] = useState('');
  const handleClose = () => {
    props.setOpen(false);
  };

  useEffect(() => {
    const types = props.triggerDetail?.trigger_type?.split(",")
    setTriggerType(types.includes("webhook") ? "webhook" : types.includes("api") ? "api" : '')
    if (types.includes("email")) {
      setTab(0)
    } else {
      setTab(1)
    }
  }, [])

  const onTabChange = (type) => {
    const types = props.triggerDetail?.trigger_type?.split(",")
    if (type === "email") {
      if (types.includes("email")) {
        setTab(0)
      }
    } else {
      if (types.includes("webhook") || types.includes("api")) {
        setTab(1)
      }
    }

  }

  return (
    <>
      {/* <Dialog id="autom-addNew-modal" className="user-detail-dialog" data-test="autom-add-new" open={true} onClose={handleClose}>
        <div className="db-tabs db-page">
          <button className={tab === 0 ? 'db-tabactive' : ''} value="license" onClick={() => onTabChange("email")}>
            {t("CONTENT.EMAIL-TRIGGER.EMAIL-CONFIGURATION")}
          </button>
          <button className={tab === 1 ? 'db-tabactive' : ''} value="about" onClick={() => onTabChange("webhook")}>
            {t("CONTENT.WEBHOOK.ADD-RULE")}
          </button>
        </div>
        <DialogContent style={{ paddingLeft: 30, paddingRight: 30 }}>
          {props.triggerDetail?.trigger_type?.split(",").includes("email") ? (
            <div
              style={{ ...buttonStyle }}
              onClick={() => setOpenEmailTrigger(true)}
            >
              <img
                style={{ width: 20, height: 18 }}
                src={mailIcon}
                alt="email-configuration"
              />
              <p style={{ ...labelStyle }}>{t('CONTENT.AUTOMS-LIST.EMAIL-CONFIGURATION')}</p>
            </div>
          ) : null}
          {triggerType === 'webhook' || triggerType === 'api' ? (
            <div
              style={{ ...buttonStyle }}
              onClick={() => setOpenWebHook(true)}
            >
              <img
                style={{ width: 20, height: 18 }}
                src={webhookIcon}
                alt="email-configuration"
              />
              <p style={{ ...labelStyle }}>{t('CONTENT.AUTOMS-LIST.WEBHOOK-CONFIGURATION')}</p>
            </div>
          ) : null}
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: "space-between",
            padding: "8px 24px 8px 24px",
          }}
        />
      </Dialog> */}
      {tab === 0 && (
        <EmailTrigger
          tab={tab} setTab={setTab}
          setOpen={handleClose}
          setOpenVariable={props.setOpenVariable}
          variables={props.variables}
          automId={props.automDetail?.id}
          onTabChange={onTabChange}
        />
      )}
      {tab === 1 && (
        <WebHook
          tab={tab} setTab={setTab}
          automId={props.automDetail.id}
          setOpen={handleClose}
          webhook="automs"
          setOpenVariable={props.setOpenVariable}
          onTabChange={onTabChange}
          variables={props.variables}
        />
      )}
    </>
  );
};

export default TriggerModal;
